import { createUseStyles } from 'react-jss'
import { SELECTED_BORDER, shadows } from 'src/config/styles'
import { typography } from '@dentalux/ui-library-core'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxWidth: 440,
    boxSizing: 'border-box',
    padding: '1px 8px',
    margin: '0 auto',
    [forPhoneOnly]: {
      padding: '0 16px 8px',
    },
  },
  clinicContainer: {
    background: theme.palette.common.white,
    padding: 12,
    borderRadius: 8,
    boxShadow: shadows[1],
    display: 'flex',
    color: theme.palette.grey[800],
    gap: 16,

    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.grey['100'],
    },
  },
  clinicInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  distanceToClinic: {
    ...typography['Lato Caption Small Bold'],
  },
  separator: { minHeight: '100%', width: 1, background: theme.palette.grey[300] },
  nextAvailableAppointment: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    whiteSpace: 'nowrap',
    justifyContent: 'center',
    textAlign: 'end',
    [forPhoneOnly]: {
      minWidth: 95,
      width: 95,
      whiteSpace: 'break-spaces',
      textAlign: 'start',
    },
  },
  appointmentStartLabel: {
    ...typography['Lato Body 2'],
    color: theme.palette.grey[700],
  },
  appointmentStart: {
    ...typography['Lato Emphasized 2'],
  },
  selected: {
    border: SELECTED_BORDER(theme),
  },

  clinicName: {
    ...typography['Lato Emphasized 1'],
    marginBottom: 8,
  },

  clinicAdress: {
    ...typography['Lato Body 2'],
  },
}))
